import { doc, onSnapshot } from "firebase/firestore";
import { useState, useEffect, useContext } from "react";

import { useLocation, useParams } from "react-router-dom";
import { AuthContext } from "../providers/AuthProvider";

export const useJobDescription = (dbRef) => {
  const { userData } = useContext(AuthContext);
  const location = useLocation();
  const params = useParams();
  const [jobDescription, setJobDescription] = useState(
    location.state.jobDescription ?? {}
  );

  const [jobDocRef] = useState(
    doc(dbRef, location.state.timesheetId, "jobDescriptions", params.uid)
  );

  useEffect(() => {
    const unSubFromJobDescription = onSnapshot(jobDocRef, (snapshot) => {
      // The creating component (see Quote.jsx's addJobDescription) navigates here before its
      // own setDoc has landed, so the first snapshot can arrive for a not-yet-existent
      // document - snapshot.data() is undefined in that case. Falling back to {} avoids
      // clobbering the good initial location.state.jobDescription with undefined and crashing
      // every unguarded jobDescription.<field> read downstream.
      setJobDescription(snapshot.data() ?? {});
    });

    return () => {
      unSubFromJobDescription();
    };
  }, [jobDocRef, userData.associatedAccounts]);

  return jobDescription;
};
